// SiteFooter.js
// Pie de página con el link a la política de privacidad. #added 3/11/26 TG

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "./ContextVars";
import translations from "./translations";

const SiteFooter = () => {
  const { language } = useContext(AppContext);
  return (
    <footer style={{ textAlign: "center", padding: "16px 20px", fontSize: 14 }}>
      <Link to="/privacy" style={{ textDecoration: "underline" }}>{translations.Footer.privacy[language]}</Link>
    </footer>
  );
};

export default SiteFooter;
